import React from 'react';

const ModifySearch = () => {
    return(
  <>
 <section className='modify_serch'>
 <div className='modify_serch_main'>
    <div className='col-msd-1 city_hotl'>
        <div className='form_gp'>
            <label>Enter City Name, Location, or Specific hotel</label>
            <input type='text' className='form-control' placeholder='Enter..' />
        </div>
    </div>
    
    <div className='col-msd-1'>
        <div className='form_gp'>
            <label>Check-In Date</label>
            <input type='text' className='form-control' placeholder='Date..' />
        </div>
    </div>
    <div className='col-msd-1'>
        <div className='form_gp'>
            <label>Check-Out Date</label>
            <input type='text' className='form-control' placeholder='Date..' />
        </div>
    </div>
    <div className='col-msd-1'>
        <div className='form_gp'>
            <label>Rooms</label>
           <select className='form-selct'>
            <option>01</option>
            <option>02</option>
            <option>03</option>
            <option>04</option>
           </select>
        </div>
    </div>
    <div className='col-msd-1'>
    <div className='form_gp'>
            <label>ADULTS (17+ YRS)</label>
           <select className='form-selct'>
            <option>01</option>
            <option>02</option>
            <option>03</option>
            <option>04</option>
           </select>
        </div>
        </div>
        <div className='col-msd-1'>
    <div className='form_gp'>
            <label>CHILDREN (0-17 YRS)</label>
           <select className='form-selct'>
            <option>01</option>
            <option>02</option>
            <option>03</option>
            <option>04</option>
           </select>
        </div>
        </div>
        <div className='col-msd-1 mt-8'>
   <a className='Serch_msd'>Modify</a>
        </div>
        </div>
 </section>
  </>
   
)};

export default ModifySearch;
